import React from "react";
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as reportsservice from '../../../services/reportsservice';
import FilterPanel, {year, duration, period, region_name, oem_id} from '../../filters/filterPanel/FilterPanel';
import {
  ANALYTICS_WRITE_ROLES, AYLA_ALLOWED_ROLES,
  DURATION,
  GoogleAnalyticsConstants,
  MONTH_NAME,
  QUARTER_NAME, REGIONS, REGIONS_FOR_EU, REGIONS_FOR_US, REGIONS_FOR_VPC
} from '../../../constants';
import ReportPage from "../ReportPage";
import TitleBar from "../../titleBar/TitleBar";
import DataSnapshot from "../../aylaTimeZone/AylaTimeZone";
import { logPageViewEvent } from "../../../services/analyticsservice";
import './DownloadDeviceReportPage.css';
import CsvReport from "../../reports/csvReport/CsvReport"
import {getReportData} from "../../../helpers/utils";
import {t} from "i18next";

class DownloadDeviceReportPage extends ReportPage {
  isDiviceReportPage = true;

  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.BillingReportsPage.title, logged_in_oem_id);
  }

  reports() {
    const filters = this.props.presistFilters;

    return {
      filters: [
        reportsservice.listOfOemModels(filters),
        reportsservice.listOfSwVersions(filters),
        reportsservice.listOfOems(filters),
      ],
      reports: [reportsservice.downloadDeviceReport(filters)]
    };
  }

  render() {
    const { fetchData, session, presistFilters } = this.props;
    const deviceReport = getReportData(this.report(reportsservice.downloadDeviceReport), 'Download_Device_Report');

    if (ANALYTICS_WRITE_ROLES.includes(session.role)) {
      return (
        <div className="downloadDeviceReportPage page">
          <TitleBar title={t('billingReports')}>
            <DataSnapshot snapShot={this.dataSnapshotTime} />
          </TitleBar>
  
          <div className="page-content-wrapper container-flex">
            <div><strong>{t('billingReportNote')}</strong></div>
  
            <div className="pageContent">
              <FilterPanel
                disabled={fetchData.fetches > 0}
                currentFilters={this.props.presistFilters}
                filters={[
                  AYLA_ALLOWED_ROLES.includes(session && session.role) && oem_id(this.report(reportsservice.listOfOems)),
                  year,
                  duration(DURATION),
                  period(this.props.presistFilters.duration === 'Monthly' ? MONTH_NAME : QUARTER_NAME),
                  process.env.REACT_APP_IS_VPC_ENVIRNOMENT === 'true'
                    ? region_name(REGIONS_FOR_VPC)
                    : process.env.REACT_APP_IS_US_ENVIRNOMENT === 'true'
                    ? region_name(REGIONS_FOR_US)
                    : process.env.REACT_APP_IS_EU_ENVIRNOMENT === 'true'
                      ? region_name(REGIONS_FOR_EU)
                      : region_name(REGIONS)
                ]}
                hideDefaultReports
              />
  
              { <CsvReport data = {deviceReport} disabled={fetchData.fetches > 0} filters={presistFilters} /> }
            </div>
          </div>
        </div>
      );
    } else {
      return <Redirect to="/overview" />;
    }
  }
}

export default connect(state => state)(DownloadDeviceReportPage);
